<template>
    <div class="pt-15 animated fadeIn masterGLaccount staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table
                                :settings="tableConfig"
                                :table-items="tableItems"
                                @load-items="getTableData"
                                ref="gofixTable">

                            <template slot="gofix_table:before-control">
                                <div class="p-3">
                                    <b-row class="justify-content-md-start align-items-center">
                                        <b-col md="2" >
                                          <gofix-form-dropdown
                                              label="Account"
                                              vLabel="client_name"
                                              :filterable="false"
                                              :clearable="false"
                                              v-model="filters.accountNumber"
                                              :reduce="account => account.account_number"
                                              :options="accounts">
                                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                              <div class="uob-originator-option">
                                                <h3>{{option.client_name}}</h3>
                                                <p>UEN: {{option.uen}}</p>
                                                <p>Account number: {{option.account_number}}</p>
                                              </div>
                                            </template>
                                          </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="2" >
                                            <gofix-form-input-date
                                                    v-model="filters.fromDate"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    desc=""
                                                    label="From Date">
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="2">
                                            <gofix-form-input-time label="From Time" v-model="filters.fromTime"></gofix-form-input-time>
                                        </b-col>
                                        <b-col md="2">
                                            <gofix-form-input-date
                                                    v-model="filters.toDate"
                                                    label="To Date"
                                                    desc=""
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                            >
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="2">
                                            <gofix-form-input-time label="To Time" v-model="filters.toTime"></gofix-form-input-time>
                                        </b-col>
                                        <b-col md="1">
                                            <gofix-button @click="reGetTableData" :loading="loading" label="Filter"></gofix-button>
                                        </b-col>
                                        <b-col md="3" class="text-right">
                                            <gofix-button v-if="filters.nextRecords" @click="prevData" :loading="loading" label="Prev" class="mr-10"></gofix-button>
                                            <gofix-button v-if="hasNext" @click="nextData" :loading="loading" label="Next"></gofix-button>
                                        </b-col>
                                    </b-row>
                                </div>
                            </template>

                            <template slot="gofix_table:transactionDateTime" slot-scope="row">
                                {{ row.item.transactionDateTime | formatDatebyMoment("DD-MM-YYYYTH:m:s","DD.MM.YY H:m:s")}}
                            </template>
                            <template slot="gofix_table:creditDebitCode" slot-scope="row">
                                <span v-if="row.item.creditDebitCode === 'D'">Debit</span>
                                <span v-if="row.item.creditDebitCode === 'C'">Credit</span>
                            </template>
                            <template slot="gofix_table:amount" slot-scope="row">
                                <span v-if="row.item.creditDebitCode === 'D'">
                                    {{row.item.debitAmount.amount | formatMoney}}
                                </span>
                                <span v-if="row.item.creditDebitCode === 'C'">
                                    {{row.item.creditAmount.amount | formatMoney}}
                                </span>
                            </template>
                            <template slot="gofix_table:ledgerBalance" slot-scope="row">
                                <json-viewer
                                :value="row.item.ledgerBalance"
                                :expand-depth="0"
                                sort></json-viewer>
                            </template>
                            <template slot="gofix_table:statementDate" slot-scope="row">
                                {{ row.item.statementDate | formatDatebyMoment("DDMMYYYY","DD.MM.YY")}}
                            </template>
                            <template slot="gofix_table:valueDate" slot-scope="row">
                                {{ row.item.valueDate | formatDatebyMoment("DDMMYYYY","DD.MM.YY")}}
                            </template>
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import JsonViewer from 'vue-json-viewer';
    import moment from 'moment';
    export default {
        name: 'uob_transaction',
        components: {JsonViewer},
        data () {
            return {
                tableConfig:{
                    name: 'uob-transaction',
                    controls:{
                        reload: false,
                        create: false,
                        delete: false,
                        tableColumnSettings: false,
                        tableExport: false,
                        tableImport: false,
                        tablePagination: false,
                        tableFilter: false,
                    },
                    filter: {},
                    page: 1,
                    limit: 100,
                    total: 0,
                    fields: [
                        {
                            key: 'sequenceNumber',
                            label: 'Sequence Number',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'transactionDateTime',
                            label: 'Transaction Date Time',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            sorting: false,
                            with:200
                        },
                        {
                            key: 'serviceBranch',
                            label: 'Service Branch',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:150px",
                            sorting: false,
                            with:150
                        },
                        {
                            key: 'transactionDesciption',
                            label: 'Transaction Desciption',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            sorting: false,
                            with:200
                        },
                        {
                            key: 'creditDebitCode',
                            label: 'Type',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:80px",
                            sorting: false,
                            with:80
                        },
                        {
                            key: 'amount',
                            label: 'Amount',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:150px",
                            sorting: false,
                            with:150
                        },
                        {
                            key: 'ledgerBalance',
                            label: 'Ledger Balance',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            sorting: false,
                            with:200
                        },
                        {
                            key: 'chequeNumber',
                            label: 'Cheque Number',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'remarks',
                            label: 'Remarks',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'tellerID',
                            label: 'Teller ID',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'yourReference',
                            label: 'Your Reference',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            sorting: false,
                            with:200
                        },
                        {
                            key: 'ourReference',
                            label: 'Our Reference',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'statementDate',
                            label: 'Statement Date',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'valueDate',
                            label: 'Value Date',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                    ],
                    sortColumn: "sequenceNumber",
                    sortDirection: "desc",
                },
                tableItems: [],
                filters:{
                    accountNumber: process.env.VUE_APP_UOB_API_URL === 'https://api-uat.uob.com.sg' ? "1013366743" : "9253437371",
                    fromDate: null,
                    fromTime: null,
                    toDate: null,
                    toTime: null,
                    nextRecords: '',
                },
                maxDate :  new Date(),
                minDate :  new Date(),
                hasNext: '',
                hasPrev: '',
                loading : false,
              accounts:process.env.VUE_APP_UOB_API_URL === 'https://api-uat.uob.com.sg' ? [
                {
                  client_name:"E M Services Ptd Ltd",
                  uen:"198803538N",
                  account_number:"1013366743",
                  account_currency:"SGD",
                  account_type:"D",
                },
                {
                  client_name:"E M REAL ESTATE PRIVATE LIMITED",
                  uen:"200100165G",
                  account_number:"1013108884",
                  account_currency:"SGD",
                  account_type:"D",
                }
              ] : [
                {
                  client_name:"E M SERVICES PRIVATE LIMITED",
                  uen:"198803538N",
                  account_number:"9253437371",
                  account_currency:"SGD",
                  account_type:"D",
                }
              ],
            }
        },
        computed: {

        },
        filters:{
            // formatDate: function(value) {
            //     moment(value)->format();
            //     return value[key];
            // }
        },
        watch: {
          "filters.nextRecords" : function(value,old){
            this.hasPrev = old;
          }
        },
        async created() {
            let d = new Date();
            this.minDate = d.setMonth(d.getMonth() - 2);
        },
        mounted: async function() {

        },
        updated: async function() {

        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                //format filters
                let filters = {
                    fromDate: this.filters.fromDate ? moment(this.filters.fromDate).format("DDMMYYYY") : null,
                    fromTime: this.filters.fromTime,
                    toDate: this.filters.toDate ? moment(this.filters.toDate).format("DDMMYYYY") : null,
                    toTime: this.filters.toTime,
                    nextRecords: this.filters.nextRecords,
                    accountNumber: this.filters.accountNumber,
                };
                await this.$store.dispatch("UOBController/getTransaction", filters)
                    .then(response => {
                        if(response.account.nextRecords){
                          this.hasNext = response.account.nextRecords;
                        }else{
                          this.hasNext = '';
                        }
                        this.tableItems = response.account.transactions ? response.account.transactions : [];
                        this.tableConfig.total = response.account.transactions ? response.account.transactions.length : 0;
                        resolve({
                            items: response.account.transactions ? response.account.transactions : [],
                            total: response.account.transactions ? response.account.transactions.length : 0
                        });
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load the data", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        this.tableItems = [];
                        this.tableConfig.total = 0;
                        reject();
                    })
            },
            async reGetTableData() {
              this.filters.nextRecords = null;
              this.$refs.gofixTable.reloadTableItems();
            },
            async nextData() {
              const nextRecords = this.hasNext;
              this.setNextRecords(nextRecords)
              this.$refs.gofixTable.reloadTableItems();
            },
            async prevData() {
              const nextRecords = this.hasPrev;
              this.setNextRecords(nextRecords)
              this.$refs.gofixTable.reloadTableItems();
            },
          setNextRecords(item){
              this.filters.nextRecords = "" + item
          }
        }
    }
</script>
